module.exports = __webpack_public_path__ + "img/cookie.08afbd30.svg";